// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"c1439689","164":"c1439689","165":"a217169c","847":"63a0e5de"}[chunkId] + ".chunk.css";
};